// tslint:disable:max-line-length

import React from 'react';

export const OperatorMultiply = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M5.78,11.18,4.47,9.87l2.2-2.21L4.47,5.47l1.3-1.32L8,6.35l2.19-2.2,1.32,1.32L9.31,7.66l2.21,2.19-1.3,1.32L8,9Z" />
    </svg>
  );
};
